/* Auto-generated from inline schema 2025-08-29T08:39:05.798Z */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: ['yes_no_nalr'],
    },
  },
  required: ['value'],
}

export const answerSchema = valueSchema
